import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { CommonModule, DatePipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';

export interface ProtocolDialogData {
  logs: any[];
  types: any[];
}

@Component({
  selector: 'protocol-dialog',
  templateUrl: './protocol-dialog.component.html',
  styleUrl: './protocol-dialog.component.scss',
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    DatePipe,
  ]
})
export class ProtocolDialogComponent {
  readonly dialogRef = inject(MatDialogRef<ProtocolDialogComponent>);
  readonly data = inject<ProtocolDialogData>(MAT_DIALOG_DATA);
  displayedColumns: string[] = ['status', 'date', 'message'];

  constructor() {
    console.log(this.data)
  }

  onClose(): void {
    this.dialogRef.close();
  }

  getType(type: string): string {
    return this.data.types.find(t => t.attribute === type)?.value ?? '';
  }
}
